module.exports = __webpack_public_path__ + "static/media/client7.87123863.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/client7.png
// module id = 303
// module chunks = 0